export default {
    title: 'Qualità',
    icon: 'mdi-quality-high',
    groups: ['Amministrazione','Qualità','Officina','Milkrun','Tecnici','Magazzino'],
    divider: true,
    submenu: [
        {
            title: 'NC interne',
            route: {name: 'qualita-nc-interne'},
            groups: ['Amministrazione','Qualità','Officina','Tecnici'],
        },
        {
            title: 'PPAP',
            route: {name: 'qualita-ppap-da-fare'},
            groups: ['Amministrazione', 'Qualità', 'Tecnici'],
        },
        {
            title: 'Mail Segnalazioni',
            route: {name: 'qualita-mail-segnalazioni'},
            groups: ['Amministrazione','Qualità','Milkrun','Tecnici','Magazzino']
        },
        {
            title: 'Stampa ODR',
            route: {name: 'qualita-stampa-odr'},
            groups: ['Amministrazione','Qualità','Milkrun','Tecnici','Magazzino']
        },
        {
            title: 'Ricevimento NC',
            route: {name: 'qualita-ricevimento-nc'},
            groups: ['Amministrazione','Qualità','Milkrun','Tecnici','Magazzino']
        },
        {
            title: 'Riepilogo NC',
            route: {name: 'qualita-riepilogo-nc'},
            groups: ['Amministrazione','Qualità','Officina','Milkrun','Tecnici','Magazzino']
        },
    ]
}
